import { NavbarVerticalItem } from '@siemens/element-ng/navbar-vertical';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

export function getNavTabs(translate: TranslateService, isAdmin: boolean): NavbarVerticalItem[] {
    const tabs: NavbarVerticalItem[] = [
        {
            type: 'router-link',
            label: translate.instant('tabs.reports'),
            icon: 'element-report-alt',
            routerLink: '/reports'
        },
        {
            type: 'router-link',
            label: translate.instant('tabs.data'),
            icon: 'element-database',
            routerLink: '/data'
        },
        {
            type: 'router-link',
            label: translate.instant('tabs.news'),
            icon: 'element-validation-information',
            routerLink: '/news'
        },
        {
            type: 'router-link',
            label: translate.instant('tabs.map'),
            icon: 'element-map-location',
            routerLink: '/map'
        }
    ];

    if (isAdmin) {
        tabs.push(
            { type: 'divider' },
            {
                type: 'link',
                label: translate.instant('tabs.userManagement'),
                icon: 'element-user-group',
                href: environment.userManagementUrl,
                target: '_blank'
            }
        );
    }

    return tabs;
}
